import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageBlock } from '../../../models/cms-models';

@Component({
  selector: 'cms-landing-page-heading-block-editor',
  imports: [CommonModule, FormsModule],
  templateUrl: './landing-page-heading-block-editor.html',
  styleUrl: './landing-page-block-editor-fields.css',
})
export class LandingPageHeadingBlockEditorComponent {
  @Input({ required: true }) block!: LandingPageBlock;
  @Output() blockChange = new EventEmitter<Partial<LandingPageBlock>>();

  updateHeading(value: string): void {
    this.blockChange.emit({ heading: value });
  }

  updateHeadingLevel(value: string): void {
    this.blockChange.emit({ headingLevel: value === '' ? null : Number(value) });
  }
}
